<template>
	<DashboardPanel class="w-full" title="My Apps">
		<div class="grid grid-cols-[repeat(auto-fill,theme(spacing.30))] gap-6 mt-6">
			<DashboardActionCard v-if="canViewMenu('resources')" title="Resources" alt_text="Resources" image_name="dashboard/black/resources.svg"
										@click.prevent="actionCardClicked({ name: 'resources' })" />
			<DashboardActionCard v-if="canViewMenu('data.submit-data') && (authStore.canUploadData || authStore.isPortalAdmin)" title="Submit Data" alt_text="Submit Data" image_name="dashboard/black/submit-data.svg"
										@click.prevent="actionCardClicked({ name: 'data.submit-data' })" />
			<DashboardActionCard v-if="canViewMenu('data.data-submissions') && (authStore.canViewAllOrgFiles || authStore.canUploadData || authStore.canDownloadData || authStore.isPortalAdmin)" :title="getSubmissionLabel('<br>')" :alt_text="getSubmissionLabel(' ')" image_name="dashboard/black/data-submissions.svg"
										@click.prevent="actionCardClicked({ name: 'data.data-submissions' })" />
			<DashboardActionCard v-if="canViewMenu('documents.manage') && (authStore.canUploadDocuments || authStore.isPortalAdmin)" title="Manage Documents" image_name="file_upload.svg"
										@click.prevent="actionCardClicked({ name: 'documents.manage' })" />
			<DashboardActionCard v-if="canViewMenu('documents.published') && (authStore.canDownloadDocuments || authStore.isPortalAdmin)" title="Published Documents" image_name="file_download.svg"
										@click.prevent="actionCardClicked({ name: 'documents.published' })" />
			<DashboardActionCard v-if="canViewMenu('learning-center')" title="Learning<br>Center" alt_text="Learning Center" image_name="dashboard/black/learning-center.svg"
										 @click.prevent="actionCardClicked({ name: 'learning-center' })" />
			<DashboardActionCard v-if="authStore.isPortalAdmin || authStore.isOrganizationAdmin" title="Admin<br>Center" alt_text="Admin Center" image_name="dashboard/black/admin-center.svg"
										@click.prevent="actionCardClicked({ name: 'admin.users' })" />
		</div>
	</DashboardPanel>
</template>

<script setup lang="js">

import DashboardActionCard from '@/components/Dashboard/DashboardActionCard.vue'
import router from '@/router/router.js'
import DashboardPanel from '@/components/Dashboard/DashboardPanel.vue'
import { useAuthStore } from '@/stores/authStore.js'
import { Tenants } from '@/models/tenants/Tenants.js'
import { UserpilotService } from '@/models/utils/UserpilotUtils.js'

const authStore = useAuthStore()

function getSubmissionLabel(separator) {
	return (authStore.isAnyAdmin || authStore.canViewAllOrgFiles) ? `Data${separator}Submissions` : `My${separator}Submissions`
}

function actionCardClicked(route)
{
	UserpilotService.track('dashboard_card_clicked', {
		"user_id": authStore.getAuth.user().id,
		"route": route
	});
	router.push(route)
}

/**
 * Checks if a menu item is disabled for a tenant.
 * @param p_route_name
 * @returns {boolean}
 */
function canViewMenu(p_route_name)
{
	return Tenants.isModuleEnabled(p_route_name)
}

</script>